/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RestockingPriorityTier = "HIGH" | "LOW" | "MEDIUM";

export type GetPublicRestockingListQueryVariables = Exact<{ [key: string]: never }>;

export type GetPublicRestockingListQuery = {
  getPublicRestockingList: {
    publicRestockingList: {
      hubSlug: string;
      restockingItems: Array<{
        sku: string;
        priorityTier: Types.RestockingPriorityTier | null;
        product: {
          sku: string;
          imageUrl: string | null;
          name: string;
          bio: boolean | null;
          productClassification: Array<string> | null;
          numberOfShelfFacings: number | null;
          numberOfShelfStackings: number | null;
          isShelvedInHandlingUnits: boolean | null;
          countryOfOrigin: { code: string | null };
          inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
        } | null;
      }>;
    };
  };
};

export type GetPublicRestockingStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPublicRestockingStatsQuery = {
  getPublicRestockingList: {
    publicRestockingList: { hubSlug: string; restockingItems: Array<{ sku: string }> };
  };
};

export const GetPublicRestockingListDocument = gql`
  query getPublicRestockingList {
    getPublicRestockingList {
      publicRestockingList {
        hubSlug
        restockingItems {
          sku
          priorityTier
          product {
            sku
            imageUrl
            name
            bio
            productClassification
            countryOfOrigin {
              code
            }
            inventoryEntry {
              shelfNumber
              stock {
                shelf
              }
            }
            numberOfShelfFacings
            numberOfShelfStackings
            isShelvedInHandlingUnits
          }
        }
      }
    }
  }
`;

/**
 * __useGetPublicRestockingListQuery__
 *
 * To run a query within a React component, call `useGetPublicRestockingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicRestockingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicRestockingListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicRestockingListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPublicRestockingListQuery,
    GetPublicRestockingListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPublicRestockingListQuery, GetPublicRestockingListQueryVariables>(
    GetPublicRestockingListDocument,
    options,
  );
}
export function useGetPublicRestockingListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicRestockingListQuery,
    GetPublicRestockingListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPublicRestockingListQuery, GetPublicRestockingListQueryVariables>(
    GetPublicRestockingListDocument,
    options,
  );
}
// @ts-ignore
export function useGetPublicRestockingListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPublicRestockingListQuery,
    GetPublicRestockingListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPublicRestockingListQuery,
  GetPublicRestockingListQueryVariables
>;
export function useGetPublicRestockingListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicRestockingListQuery,
        GetPublicRestockingListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPublicRestockingListQuery | undefined,
  GetPublicRestockingListQueryVariables
>;
export function useGetPublicRestockingListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicRestockingListQuery,
        GetPublicRestockingListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPublicRestockingListQuery,
    GetPublicRestockingListQueryVariables
  >(GetPublicRestockingListDocument, options);
}
export type GetPublicRestockingListQueryHookResult = ReturnType<
  typeof useGetPublicRestockingListQuery
>;
export type GetPublicRestockingListLazyQueryHookResult = ReturnType<
  typeof useGetPublicRestockingListLazyQuery
>;
export type GetPublicRestockingListSuspenseQueryHookResult = ReturnType<
  typeof useGetPublicRestockingListSuspenseQuery
>;
export type GetPublicRestockingListQueryResult = Apollo.QueryResult<
  GetPublicRestockingListQuery,
  GetPublicRestockingListQueryVariables
>;
export const GetPublicRestockingStatsDocument = gql`
  query getPublicRestockingStats {
    getPublicRestockingList {
      publicRestockingList {
        hubSlug
        restockingItems {
          sku
        }
      }
    }
  }
`;

/**
 * __useGetPublicRestockingStatsQuery__
 *
 * To run a query within a React component, call `useGetPublicRestockingStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicRestockingStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicRestockingStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicRestockingStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPublicRestockingStatsQuery,
    GetPublicRestockingStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPublicRestockingStatsQuery, GetPublicRestockingStatsQueryVariables>(
    GetPublicRestockingStatsDocument,
    options,
  );
}
export function useGetPublicRestockingStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicRestockingStatsQuery,
    GetPublicRestockingStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPublicRestockingStatsQuery, GetPublicRestockingStatsQueryVariables>(
    GetPublicRestockingStatsDocument,
    options,
  );
}
// @ts-ignore
export function useGetPublicRestockingStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPublicRestockingStatsQuery,
    GetPublicRestockingStatsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPublicRestockingStatsQuery,
  GetPublicRestockingStatsQueryVariables
>;
export function useGetPublicRestockingStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicRestockingStatsQuery,
        GetPublicRestockingStatsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPublicRestockingStatsQuery | undefined,
  GetPublicRestockingStatsQueryVariables
>;
export function useGetPublicRestockingStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPublicRestockingStatsQuery,
        GetPublicRestockingStatsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPublicRestockingStatsQuery,
    GetPublicRestockingStatsQueryVariables
  >(GetPublicRestockingStatsDocument, options);
}
export type GetPublicRestockingStatsQueryHookResult = ReturnType<
  typeof useGetPublicRestockingStatsQuery
>;
export type GetPublicRestockingStatsLazyQueryHookResult = ReturnType<
  typeof useGetPublicRestockingStatsLazyQuery
>;
export type GetPublicRestockingStatsSuspenseQueryHookResult = ReturnType<
  typeof useGetPublicRestockingStatsSuspenseQuery
>;
export type GetPublicRestockingStatsQueryResult = Apollo.QueryResult<
  GetPublicRestockingStatsQuery,
  GetPublicRestockingStatsQueryVariables
>;
